import { render, staticRenderFns } from "./collection_banners.vue?vue&type=template&id=a4298b28&"
import script from "./collection_banners.vue?vue&type=script&lang=js&"
export * from "./collection_banners.vue?vue&type=script&lang=js&"
import style0 from "./collection_banners.vue?vue&type=style&index=0&id=a4298b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports